import { DataServiceService } from './service/data-service.service';
import { FiledownloadComponent } from './filedownload/filedownload.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule} from 'ng2-bootstrap';
import { ModalModule } from 'ngx-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HomeComponent } from './home/home.component';
import { WebsitemapComponent } from './websitemap/websitemap.component';
import { GovOpenAnnounceComponent } from './gov-open-announce/gov-open-announce.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { WebSecurityComponent } from './web-security/web-security.component';
import { HttpClientModule } from '@angular/common/http';




@NgModule({
  declarations: [
    AppComponent, FiledownloadComponent, HomeComponent, WebsitemapComponent, GovOpenAnnounceComponent, PrivacyComponent, WebSecurityComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    AppRoutingModule,
  ],
  providers: [
    DataServiceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
